import { map, clone } from 'lodash';

const endpoint = property => `/api/${property}/events/options`;

export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    save: option => {
      let url = option.id ? `${ endpoint(api.property()) }/${ option.id }` : endpoint(api.property());

      return api.upload(url, option).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property())}?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/options.service.js